import { RefObject, useEffect } from 'react';

type UseScrollIntoViewProps = {
  elementRef: RefObject<HTMLElement | null> | null;
  isVisible: boolean;
};

const useScrollIntoView = ({ elementRef, isVisible }: UseScrollIntoViewProps) => {
  useEffect(() => {
    if (isVisible && elementRef?.current) {
      const element = elementRef?.current as HTMLElement;
      element?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
    }
  }, [isVisible, elementRef]);
};

export default useScrollIntoView;
